import { routes } from '@/infrastructure/const/routes';
import { getReciterSurahPath } from './get-reciter-surah-path';

interface IGetAudioSurahPathParams {
  reciterSlug?: string;
  surahNumber: number;
  getSurahSlugByNumber: (number: number) => string | undefined;
}

export const getAudioSurahPath = ({
  reciterSlug,
  surahNumber,
  getSurahSlugByNumber,
}: IGetAudioSurahPathParams): string => {
  const surahSlug = getSurahSlugByNumber(surahNumber);
  if (reciterSlug && surahSlug) {
    return getReciterSurahPath(reciterSlug, surahSlug);
  }
  if (reciterSlug) {
    return `${routes.reciters}/${reciterSlug}`;
  }
  return routes.reciters;
};
